<template>
  <div class="app">
    <div class="info">
      <span>Apps</span>
    </div>
    <div class="info">
      <btn
        name="Create App"
        @click="create"
      />
    </div>
    <list
      :items="apps"
      :columns="columns"
      :buttons="buttons"
      @click="click"
      @edit="edit"
      @delete="deleteApp"
    />
    <form-dialog
      v-if="formDialog"
      :item="item"
      :header="headerTitle"
      @cancel="formDialog = false; editing = false;"
      @save="save"
    />
  </div>
</template>

<script>
  import gql from 'graphql-tag';

  export default {
    name: 'AppIndex',
    components: {
      list: () => import('@/views/admin/components/list.vue'),
      'form-dialog': () => import('@/views/admin/components/form-dialog.vue'),
      btn: () => import('@/views/admin/components/btn.vue'),
    },
    props: {},
    data() {
      return {
        formDialog: false,
        buttons: [{ name: 'Edit', callback: 'edit' }, { name: 'Delete', callback: 'delete' }],
        editing: false,
        item: {
          name: { value: '' },
          key: { value: '' },
          redirect: { value: '' },
          url: { value: '' },
          secret: { value: '' },
          theme: { value: '' },
        },
        columns: [
          {
            name: 'ID',
            key: 'id',
          },
          {
            name: 'Name',
            key: 'name',
          },
          {
            name: 'Key',
            key: 'key',
          },
          {
            name: 'Redirect',
            key: 'redirect',
          },
          {
            name: 'URL',
            key: 'url',
          },
          {
            name: 'Secret',
            key: 'secret',
          },
          {
            name: 'Theme',
            key: 'theme',
          },
        ],
        apps: [],
      };
    },
    apollo: {
      apps:
        gql`query {
          apps {
            id key name redirect url secret theme
            roles {
              id
            }
          }
          }`,
    },
    computed: {
      headerTitle() {
        return this.editing ? 'Edit App' : 'Create App';
      },
    },
    watch: {},
    mounted() {},
    methods: {
      create() {
        this.item = {
          name: { value: '' },
          key: { value: '' },
          redirect: { value: '' },
          url: { value: '' },
          secret: { value: '' },
          theme: { value: '' },
        };
        this.formDialog = true;
        this.editing = false;
      },
      save(item) {
        if (this.editing) {
          this.$apollo.mutate({
            mutation: gql`
                mutation($name: String!, $key: String!, $redirect: String!, $secret: String!, $url: String!, $id: String!, $theme: String) {
                updateOneApp(data: { name: { set: $name }, key: { set: $key }, redirect: { set: $redirect }, secret: { set: $secret }, url: { set: $url }, theme: { set: $theme } }, where: {id: $id}) {
                  id
                  name
                }
              }
          `,
            variables: {
              id: item.id.value,
              name: item.name.value,
              key: item.key.value,
              redirect: item.redirect.value,
              secret: item.secret.value,
              url: item.url.value,
              theme: item.theme.value,
            },
          }).then(() => {
            this.$apollo.queries.apps.refetch();
          });
        } else {
          this.$apollo.mutate({
            mutation: gql`
                mutation($name: String!, $key: String!, $redirect: String!, $secret: String!, $url: String!, $theme: String) {
                createOneApp(data: { name: $name, key: $key, redirect: $redirect, secret: $secret, url: $url, theme: $theme }) {
                  id
                  name
                }
              }
          `,
            variables: {
              name: item.name.value,
              key: item.key.value,
              redirect: item.redirect.value,
              secret: item.secret.value,
              url: item.url.value,
              theme: item.theme.value,
            },
          }).then(() => {
            this.$apollo.queries.apps.refetch();
          });
        }
        this.editing = false;
        this.formDialog = false;
      },
      edit(item) {
        Object.assign(this.item, {
          id: { value: item.id, disabled: true },
          name: { value: item.name },
          key: { value: item.key },
          redirect: { value: item.redirect },
          url: { value: item.url },
          secret: { value: item.secret },
          theme: { value: item.theme },
        });
        this.editing = true;
        this.formDialog = true;
      },
      click(item) {
        this.$router.push({ name: 'app/show', params: { id: item.key } });
      },
      deleteApp(item) {
        if (window.confirm('Are you sure you want to delete this app? This will delete all roles and grants for this app.')) {
          this.$apollo.mutate({
            mutation: gql`
                mutation($id: String!) {
                  deleteApp(id: $id) {
                    id
                  }
                }
              `,
            variables: {
              id: item.id,
            },
          }).then(() => {
            this.$apollo.queries.apps.refetch();
          });
        }
      },
    },
  };
</script>


<style lang="stylus" scoped>

</style>
